import DataType from '@opsbase/lib-datatype/DataType';
import FormQuestionType from '@opsbase/lib-form/FormQuestionType/FormQuestionType';
import getScore from '@opsbase/lib-form/helpers/getScore';
import DeviceType, { deviceTypeLabel } from '@opsbase/lib-general/DeviceType/DeviceType';
import GradingMethodType from '@opsbase/lib-grading/GradingMethodType';
import i18n from '@opsbase/lib-i18n';
import opIs from '@opsbase/lib-op/helpers/opIs';
import { opStatusColor } from '@opsbase/lib-op/OpStatus';
import Palette from '@opsbase/lib-palette';
import { SimpleDateFormat, SimpleTimeFormat } from '@opsbase/lib-time/consts';
import { humanizeFromNow } from '@opsbase/lib-time/utils';
import Chip from '@opsbase/web-chips/Chip';
import DataPill from '@opsbase/web-chips/DataPill';
import GradeChip from '@opsbase/web-chips/GradeChip';
import OpStatusChip from '@opsbase/web-chips/OpStatusChip';
import PassStatusChip from '@opsbase/web-chips/PassStatusChip';
import ScoreChip from '@opsbase/web-chips/ScoreChip';
import useCss from '@opsbase/web-css';
import DotToDotIcon from '@opsbase/web-icons/icons/DotToDotIcon';
import ImageViewer from '@opsbase/web-image/ImageViewer';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import FieldSet from '@opsbase/web-ui/FieldSet';
import Text from '@opsbase/web-ui/Text';
import moment from 'moment-timezone';
import React from 'react';
import GoogleMap from '../../../shared/UI/GoogleMap';
import OpViewOverviewSectionScore from './OpViewOverviewSectionScore';
const makeMyClasses = () => ({
    root: {
        overflow: 'auto',
    },
});
export function OpViewOverview(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { op } = props;
    const parsedForm = op.getParsedForm();
    const score = getScore(parsedForm);
    const isMissed = opIs.missed(op);
    const isSubmitted = opIs.submitted(op);
    const isEarly = opIs.early(op);
    const sectionQuestions = (_b = (_a = op.form) === null || _a === void 0 ? void 0 : _a.filter(q => q.type === FormQuestionType.SECTION)) !== null && _b !== void 0 ? _b : [];
    const myCss = useCss(makeMyClasses);
    return (React.createElement(Vertical, { gutter: true, padding: true, classes: { root: myCss.root } },
        React.createElement(OpStatusChip, { op: op }),
        React.createElement(FieldSet, { label: i18n.t('due') },
            React.createElement(Horizontal, { gutter: true },
                React.createElement(DateTimeBox, { vertical: true, showFromNow: true, op: op, fieldName: 'completeBy' }),
                React.createElement(DataPill, { value: ((_c = op.place) === null || _c === void 0 ? void 0 : _c.title) || '', type: DataType.PLACE, textWidth: 150 }))),
        !!isEarly && (React.createElement(FieldSet, { label: i18n.t('startable') },
            React.createElement(DateTimeBox, { vertical: true, showFromNow: true, op: op, fieldName: 'startFrom' }))),
        !!isMissed && (React.createElement(FieldSet, { label: i18n.t('missed-deadline') },
            React.createElement(DateTimeBox, { vertical: true, showFromNow: true, op: op, fieldName: 'missedDeadlineDate' }))),
        !isSubmitted && (React.createElement(FieldSet, { label: i18n.t('assignee') },
            React.createElement(Vertical, { gutter: true },
                React.createElement(Pane, null,
                    op.allPTsPermitted && (React.createElement(Chip, { fullWidth: true, color: Palette.WhiteSmoke, label: i18n.t('all-teams-positions') })),
                    op.teams.map((t, idx) => (React.createElement(DataPill, { key: 'team' + idx, value: t.title, type: DataType.TEAM, textWidth: 150 }))),
                    op.positions.map((p, idx) => (React.createElement(DataPill, { key: 'position' + idx, value: p.title, type: DataType.POSITION, textWidth: 150 }))))))),
        React.createElement(FieldSet, { label: i18n.t('status') },
            React.createElement(Vertical, { gutter: true },
                !!isSubmitted && (React.createElement(DataPill, { value: (_d = op.submittedBy) === null || _d === void 0 ? void 0 : _d.title, type: DataType.STAFF })),
                React.createElement(Horizontal, null,
                    React.createElement(DotToDotIcon, { color: opStatusColor(op.status), style: { height: 38, width: 28 } }),
                    React.createElement(Vertical, null,
                        React.createElement(DateTimeBox, { op: op, label: i18n.t('started'), fieldName: 'actualStart', emptyStr: i18n.t('not-started') }),
                        React.createElement(DateTimeBox, { op: op, label: i18n.t('completed'), fieldName: 'actualComplete', emptyStr: i18n.t('not-complete') }))),
                !!((_e = op.startedBy) === null || _e === void 0 ? void 0 : _e.title) && (React.createElement(Text, { variant: "small" }, i18n.t('started-by') + ' ' + ((_f = op.startedBy) === null || _f === void 0 ? void 0 : _f.title))),
                !!isSubmitted && (React.createElement(Text, { variant: "small" }, i18n.t('completed-on') +
                    ' ' +
                    deviceTypeLabel(op.completedOnDeviceType || DeviceType.NATIVE))))),
        isSubmitted && !!op.hasImage && (React.createElement(FieldSet, null,
            React.createElement(ImageViewer, { fileNames: [op.id], size: 100 }))),
        isSubmitted && (React.createElement(FieldSet, { label: i18n.t('scoring') },
            React.createElement(Vertical, { gutter: true },
                React.createElement(Horizontal, { gutter: true },
                    !!op.isScoreEnabled && score.max > 0 && (React.createElement(Pane, null,
                        React.createElement(ScoreChip, { scoreMax: score.max, scoreTotal: score.total }))),
                    ((_g = op.gradingMethod) === null || _g === void 0 ? void 0 : _g.gradingMethodType) !== GradingMethodType.NONE && (React.createElement(Pane, null,
                        React.createElement(PassStatusChip, { status: op.passFailStatus })))),
                ((_h = op.gradingMethod) === null || _h === void 0 ? void 0 : _h.gradingMethodType) === GradingMethodType.CALCULATED && (React.createElement(Pane, null,
                    React.createElement(GradeChip, { grade: op.grade }))),
                sectionQuestions.map(s => (React.createElement(OpViewOverviewSectionScore, { ...props, section: s })))))),
        React.createElement(Pane, { grow: true }),
        !!op.opPerformedLocation && (React.createElement(Pane, null,
            React.createElement(GoogleMap, { location: op.opPerformedLocation, width: "100%", height: 180 })))));
}
export default OpViewOverview;
function dateInTz(op, fieldName) {
    var _a;
    return ((_a = op.place) === null || _a === void 0 ? void 0 : _a.timezone) ? moment(op[fieldName]).tz(op.place.timezone) : moment(op[fieldName]);
}
function DateTimeBox({ op, fieldName, showFromNow = false, label = '', emptyStr = '', vertical = false, }) {
    if (!op[fieldName])
        return React.createElement(Text, null, emptyStr);
    const m = dateInTz(op, fieldName);
    if (vertical) {
        return (React.createElement(Vertical, null,
            !!label && (React.createElement(Pane, { shrink: true, style: { minWidth: 60 } },
                React.createElement(Text, { color: Palette.GreyBlue, variant: "small" }, label))),
            React.createElement(Text, null, m.format(SimpleTimeFormat)),
            React.createElement(Text, { variant: "small" }, m.format(SimpleDateFormat)),
            showFromNow && React.createElement(Text, { variant: "small" }, humanizeFromNow(m))));
    }
    else {
        return (React.createElement(Horizontal, { centered: true, gutter: true },
            !!label && (React.createElement(Pane, { shrink: true, style: { minWidth: 60 } },
                React.createElement(Text, { color: Palette.GreyBlue, variant: "small" }, label))),
            React.createElement(Text, null, m.format(SimpleTimeFormat)),
            React.createElement(Pane, { grow: true }),
            React.createElement(Text, { variant: "small" }, m.format(SimpleDateFormat))));
    }
}
